import axios from 'axios';
import { apiUrl } from '../../config/settings';

export const getLocales = () => {
  return async (dispatch) => {
    try {
      const response = await axios.get(`${apiUrl}/locales`);
      dispatch({ type: 'SET_LOCALES', data: response.data });
    } catch (error) {
      console.error(error);
    }
  };
};
